module.exports = __webpack_public_path__ + "img/red-button@2x.5e80bd09.png";